//webSocket 保活
import { PrintWaiting, startPrinting } from '@/util/ptintTool.js';
import home from "@/api/home";
import setTemp from '@/api/setTemplate';
import util from "@/util/util";
import store from "../pages/home/store/index";
import Route from '../pages/home/router/router'
import { getLodop } from "@/util/LodopFuncs";
import Vue from 'vue'
class WebSocketClass {
  constructor() {
    this.lockReconnect = false;
    this.dkspacing = util.getJsonValues(store.state.commondict,'submittime') || 3
  }
  connect(wsUrl) {
    this.ws = new WebSocket(wsUrl);
    this.ws.onopen = e => {
      this.status = 'open';
      console.log(`连接成功`, e);
      store.dispatch("getprintName");
      this.lockReconnect = true;
      this.storeChange(true)
      this.heartCheck();
      this.getMessage();
    };
    this.ws.onerror = e =>{
      console.log('连接失败', e);
      this.storeChange(false)
      this.reconnect()
    }
    this.ws.onclose = e =>{
      this.storeChange(false)
      this.reconnect()
      console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
      // ++
    }
  }
  heartCheck() {
    // 心跳机制的时间可以自己与后端约定
    this.pingPong = 'ping'; // ws的心跳机制状态值
    if(this.pingInterval !== undefined){
      clearInterval(this.pingInterval);
    }
    this.pingInterval = setInterval(() => {
      if (this.ws.readyState === 1) {
        // 检查ws为链接状态 才可发送
        // console.log(this.CheckIsInstall())
        const submit = {
          account_id: util.getCookie("account_id"),
          pc_printer_name: util.getCookie('defult_print') || '',
          login_status:1, //电脑端已登录0-未登录,1-已登录
          print_plugin_status:this.CheckIsInstall() ? 1 : 0, //打印机插件已安装0-未安装，1-已安装
          websocket_status:1, //websocket通讯正常0-未连接，1-连接正常
          pc_printer_default: 0, //电脑端默认打印机设置
          configver:JSON.parse(store.state.commondict).ext_info||0,//通用配置的版本号本地记忆
          app_key:util.getCookie("app_key"),
          ws_token:util.getCookie('websocket_token')
        }
        // console.log(submit)
        this.ws.send('ping,'+JSON.stringify(submit)); // 客户端发送ping
        //校验是否有未读消息
        if(util.getCookie('noreadnum')){
          store.state.mailnum = 0;
          util.removeCookie('noreadnum')
        }
      }
    }, 2000);
    if(this.pongInterval !== undefined){
      clearInterval(this.pongInterval);
    }
    this.pongInterval = setInterval(() => {
      if (this.pingPong === 'ping') {
        this.closeHandle('pingPong没有改变为pong'); // 没有返回pong 重启webSocket
      }
      // 重置为ping 若下一次 ping 发送失败 或者pong返回失败(pingPong不会改成pong)，将重启
      // console.log('返回pong');
      //更新连接图标
      this.storeChange(true)
      this.pingPong = 'ping';
    }, 4000);
  }
  closeHandle(e = 'err') {
    // 因为webSocket并不稳定，规定只能手动关闭(调closeMyself方法)，否则就重连
    this.storeChange(false)
    if (this.status !== 'close') {
      console.log(`断开，重连websocket`, e);
      if (this.pingInterval !== undefined && this.pongInterval !== undefined) {
        // 清除定时器
        clearInterval(this.pingInterval);
        clearInterval(this.pongInterval);
      }
      this.close();
      this.lockReconnect = false;
      this.reconnect();
    } else {
      console.log(`websocket手动关闭,或者正在连接，status=close`);
    }
  }
  getMessage() {
    this.ws.onmessage = e => {
      if (e.data === 'pong') {
        this.pingPong = 'pong'; // 服务器端返回pong,修改pingPong的状态
      } else if (e.data === 'pong:401'){
        this.close()
        util.removeCookie('account_id')
        util.removeCookie('websocket_token')
        util.removeCookie('token')
        Route.push({path: '/login'})
      } else {
        this.pingPong = 'pong';
        // console.log(e.data,'打印指令');
        const obj = JSON.parse(e.data)
        if(obj.act == 'TOAST'){
          Vue.prototype.$toast(true,obj.data.data,'upFinsh')
        } else if (obj.act == 'MESSAGE'){
          console.log(obj,'提示')
          try{
            const mesObj = JSON.parse(obj.data);
            Vue.prototype.$message({
              type: mesObj.type,
              message: mesObj.info,
            })            
          }
          catch(error){
            console.log("MESSAGE出错" + error)
          }

        } else if (obj.act == 'updatecfg') {
          home.commondict(this).then(res=>{
            if(res.success){
              store.commit('SET_COMMON_DICT',JSON.stringify(res.data))
            }     
          })
        } else if (obj.act == 'updatebind') {
          store.commit('SET_BIND_KDY',res.data.bind)
        }else { 
          PrintWaiting(Vue.prototype).then( res=>{
            if (res.initPrint) {
              const changePrinted = {
                'act': "print",
                'orders': obj.orders,
                'unique_no':obj.uniqueNo,
                account_id: util.getCookie("account_id")
              }
              if(obj.data.length) this.ws.send(JSON.stringify(changePrinted));
              const num = util.getJsonValues(store.state.commondict,'packsize') - 0 || 10
              var groupedArray = util.arrayGroup(obj.data, num);
              var orders = util.arrayGroup(obj.orders, num)
              for(let i = 0;i< groupedArray.length;i++){
                startPrinting(groupedArray[i]).then(res => {
                  if(res.finish){
                    //最后一组刷新页面列表状态
                    if(i+1 == orders.length){store.commit('SET_LIST_REFRESH',new Date().getTime())}                 
                  }
                })                  
              }   
            }
          })    
        }        
      }
      // console.log(e.data);
      return e.data;
    };
  }
  envConnect(){
    //重连
    if(util.jgEnv()=='pro'){
      // 生产环境
      this.connect('wss://ysb.yundasys.com/ws/subscribe?wsToken='+util.getCookie('websocket_token')+'&appKey='+ util.getCookie("app_key"));
    }else{
      // 测试环境
      this.connect('wss://u-openapi.yundasys.com/ws/subscribe?wsToken='+util.getCookie('websocket_token')+'&appKey='+ util.getCookie("app_key"));
    }
  }
  //通信图标更改
  storeChange(flag){
    store.state.connetStatus = {
      WebSocketstatus:flag ? 1 : 0,
      name:util.getCookie('defult_print') || '',
      lodopStatus:this.CheckIsInstall(),
    } 
    // console.log(store.state.connetStatus)
  }
  close() {
    clearInterval(this.pingInterval);
    clearInterval(this.pongInterval);
    this.status = 'close';
    this.lockReconnect = true;
    try{
      this.ws.close();
    }
    catch(err) {
      console.log(err+'暂无connect连接')
    }
    this.storeChange(false)
    console.log('已断开连接');
    console.log('close');
  }
  //重连
  reconnect(){
    if (this.lockReconnect) return;
    this.lockReconnect = true;
    setTimeout(()=>{     //没连接上会一直重连，设置延迟避免请求过多
      console.log('尝试重连')
      this.envConnect()
      this.lockReconnect = false;
    }, 3000);
  }
  //判断插件安装状态
  CheckIsInstall() {	 
		try{ 
		  var LODOP=getLodop(); 
			if (LODOP.VERSION) {
        return true
				//  if (LODOP.CVERSION)
				//  alert("当前有WEB打印服务C-Lodop可用!\n C-Lodop版本:"+LODOP.CVERSION+"(内含Lodop"+LODOP.VERSION+")"); 
				//  else
				//  alert("本机已成功安装了Lodop控件！\n 版本号:"+LODOP.VERSION); 
			};
		 }catch(err){ 
      // util.removeCookie('defult_print');
      return false
 		 } 
	}; 

}

export default new WebSocketClass();


